const state = {
  loading: false,
  historySearch: [],
  carLength: 0,
  carList: [],
  flag: true
};
export default state
